import React, { forwardRef } from 'react';
import { StyledLink } from './ExternalLink.styled';
import { IExternalLink } from '../../../../common/interfaces/buttons';

export const ExternalLink = forwardRef<HTMLAnchorElement, IExternalLink>(
  (
    {
      children,
      newTab = false,
      variant = 'default',
      target,
      rel,
      ...rest
    },
    ref
  ) => {
    const mergedTarget = target ?? (newTab ? '_blank' : undefined);
    const mergedRel =
      mergedTarget === '_blank'
        ? Array.from(
            new Set([
              ...(rel?.split(/\s+/).filter(Boolean) ?? []),
              'noopener',
              'noreferrer',
            ])
          ).join(' ')
        : rel;

    return (
      <StyledLink
        ref={ref}
        $variant={variant}
        target={mergedTarget}
        rel={mergedRel}
        {...rest}
      >
        {children}
      </StyledLink>
    );
  }
);
